export default __webpack_public_path__ + "static/media/Green0006.0e7c4688.png";